import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createKeyShout = async (payload: Record<string, unknown>) => {
	const response = await cmsClient.post<IKeyShout>(
		"/homepage/admin/keyshout/",
		payload
	);

	return response.data;
};

const useCreateKeyShout = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Key shout created successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["key-shouts"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(createKeyShout, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useCreateKeyShout;
